module.exports = __webpack_public_path__ + "img/_5.400560ad.png";